import { useSelector } from 'react-redux'
import {
  selectCustomerSubscriptionData,
  selectElectricityMeterSubscriptionData,
  selectGasMeterSubscriptionData,
  selectMainAddressSubscriptionData,
} from '@/containers/SubscriptionFormPage/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectProviderConfiguration } from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSelectors'
import { E_SIGN_PROVIDER_NAMES } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import { useTranslation } from 'react-i18next'

const useModalContent = () => {
  const { t } = useTranslation()
  const { name: ownerName, lang, country } = useSelector(selectAuthData)
  const { email, phone1: phone } = useSelector(selectCustomerSubscriptionData)
  const { city } = useSelector(selectMainAddressSubscriptionData)
  const { name: providerName } = useSelector(selectProviderConfiguration)
  const dateLanguage = `${lang}-${lang.toUpperCase()}`
  const date = new Date().toLocaleString(dateLanguage, { timeZone: 'Europe/Paris' })
  const { pceNo: pce } = useSelector(selectGasMeterSubscriptionData)
  const { pdlNo: pdl } = useSelector(selectElectricityMeterSubscriptionData)
  const isItaly = country === 'it'
  const isItalyOctopusProvider = isItaly && providerName?.toLowerCase() === 'octopus'

  const recordingScriptText =
    E_SIGN_PROVIDER_NAMES.includes(providerName?.toLowerCase()) && isItaly
      ? t('subscriptionForm:header.modal.recording_script_e_sign', {
          ownerName,
          providerName,
          date,
          email,
          phone,
          city,
        })
      : t('subscriptionForm:header.modal.recording_script')
  const recordingOctopusScript = t('subscriptionForm:header.modal.recording_script_e_sign_octopus', {
    ownerName,
    date,
    email,
    phone,
    city,
    pdl,
    pce,
  })

  return {
    recordingScriptText: isItalyOctopusProvider ? recordingOctopusScript : recordingScriptText,
  }
}

export default useModalContent
